let notifyHandler = null;

export function setNotifyHandler(handler) {
    notifyHandler = handler;
}

function send(type, message, options = {}) {
    notifyHandler?.({
        type,
        text: message,
        ...options,
    });
}

export const notificationService = {
    info(message, duration) {
        send('primary', message, {
            duration: duration || 3000,
        });
    },

    warning(message, duration) {
        send('warning', message, {
            speed: 500,
            duration: duration || 4000,
        });
    },

    error(message) {
        send('danger', message, {
            speed: 500,
            duration: 5000,
        });
    },
};

export default notificationService;
